import { useLang } from "@/i18n/LangContext";
import { motion } from "framer-motion";

export default function LangToggle({ testId = "lang-toggle", className = "" }) {
  const { lang, toggle } = useLang();
  return (
    <button
      onClick={toggle}
      data-testid={testId}
      aria-label="Toggle language"
      className={`relative inline-flex items-center gap-2 border border-[#222] px-3 h-10 chapter-num text-[#F4F1EB] hover:border-[#F4F1EB] transition-colors ${className}`}
    >
      <span className={lang === "en" ? "text-[#F4F1EB]" : "text-[#66635C]"}>EN</span>
      <span className="text-[#66635C]">/</span>
      <span className={lang === "ar" ? "text-[#F4F1EB]" : "text-[#66635C]"}>ع</span>
      <motion.span
        initial={false}
        className="absolute top-1 bottom-1 w-8 border border-[#C84C35] pointer-events-none"
        animate={{ left: lang === "en" ? 6 : 40 }}
        transition={{ duration: 0.5, ease: [0.76, 0, 0.24, 1] }}
      />
    </button>
  );
}
